import View from './view';





export default View.extend( {

    serialize() {
        return {
            attachments: () => this.attachments()
        };
    },

    attachments() {
        const attachments = typeof this.options.attachments === 'function'
            ? this.options.attachments()
            : this.options.attachments;

        return attachments || [];
    },

    afterRender() {
        this.attachments()
            .forEach( (att, index) => {
                if (att.uploading instanceof Promise)
                    att.uploading.then( () => 
                        this.$( '.attachment' ).eq( index ).removeClass( '--attachment-loading' ) );
                else
                    this.$( '.attachment' ).eq( index ).removeClass( '--attachment-loading' );
            } );
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/attachments.list.js